import { createAction } from "redux-actions";

export const SETTINGS_TOGGLE = "ui/settings_toggle";
export const LEVELS_TOGGLE = "ui/levels_toggle";
export const LOGIN_TOGGLE = "ui/login_toggle";
export const PAYWALL_TOGGLE = "ui/paywall_toggle";
export const SECRET_TOGGLE = "ui/secret_toggle";
export const SOLVED_TOGGLE = "ui/solved_toggle";
export const LANGUAGES_TOGGLE = "ui/languages_toggle";
export const PLAYERS_TOGGLE = "ui/players_toggle";
export const PRIZES_TOGGLE = "ui/prizes_toggle";
export const ABOUT_TOGGLE = "ui/about_toggle";

export const toggleSettings = createAction(SETTINGS_TOGGLE);
export const toggleLevels = createAction(LEVELS_TOGGLE);
export const toggleLogin = createAction(LOGIN_TOGGLE);
export const togglePaywall = createAction(PAYWALL_TOGGLE);
export const toggleSecret = createAction(SECRET_TOGGLE);
export const toggleSolved = createAction(SOLVED_TOGGLE);
export const toggleLanguages = createAction(LANGUAGES_TOGGLE);
export const togglePlayers = createAction(PLAYERS_TOGGLE);
export const togglePrizes = createAction(PRIZES_TOGGLE);
export const toggleAbout = createAction(ABOUT_TOGGLE);



// WEBPACK FOOTER //
// ./src/reducers/ui/actions.js